import { BreadCrumbsInterface } from '../interface/interface';

export function generateSearchBreadcrumbs(state: any) {
  const items: Array<BreadCrumbsInterface> = [];

  if (state?.brandValue) {
    items.push(
      { tag: 'p', children: <span>Brand</span> },
      {
        tag: 'p',
        children: <span>{state.brandValue}</span>,
      },
    );
  }

  if (state?.activeCategory) {
    items.push(
      { tag: 'p', children: <span>Products</span> },
      {
        tag: 'p',
        children: <span>{state.activeCategory}</span>,
      },
    );
  }

  if (state?.activeFormulation) {
    items.push({
      tag: 'p',
      children: <span>{state.activeFormulation}</span>,
    });
  }

  if (state?.area) {
    items.push({
      tag: 'p',
      children: <span>{state.area}</span>,
    });
  }

  return items;
}
